export default __webpack_public_path__ + "static/media/agriculture2.82fc4392.jpg";